import User from "le-coffre-resources/dist/Notary";
import Users from "@Front/Api/LeCoffreApi/Notary/Users/Users";
import { useRolePermissions } from "@Front/Stores/RolePermissionsStore";
import { useCallback, useState } from "react";
import { useLoadUserWhenPermitted } from "@Front/Hooks/useLoadUserWhenPermitted";

export interface UseUserReturn {
	user: User | null;
	refetchUser: () => Promise<void>;
}

export default function useUser(): UseUserReturn {
	const [user, setUser] = useState<User | null>(null);
	const { permissionContext, can } = useRolePermissions();
	useLoadUserWhenPermitted(setUser);
	const refetchUser = useCallback(async () => {
		const userId = permissionContext?.userId;
		if (!userId || !can("users", "read")) {
			return;
		}
		const fetched = await Users.getInstance().getByUid(userId, {
			q: {
				contact: true,
			},
		});
		setUser(fetched);
	}, [permissionContext?.userId, can]);
	return {
		user,
		refetchUser,
	};
}
